// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"787c1a0a","487":"71b4dea8","707":"2dbd5a7f"}[chunkId] + ".chunk.js";
};